// services/siteService.js
import api from "./api";

export const getSites = async (schemaName = null) => {
  try {
    const response = await api.get("/sites/", {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sites:", error);
    throw error;
  }
};

export const getSitesWithParams = async (params = {}) => {
  try {
    const response = await api.get("/sites/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching sites:", error);
    throw error;
  }
};

export const deleteSite = async (siteId, schemaName = null) => {
  try {
    const response = await api.delete(`/sites/${siteId}/`, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting site:", error);
    throw error;
  }
};

export const addSite = async (siteData, schemaName = null) => {
  try {
    const response = await api.post("/sites/", siteData, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding site:", error);
    throw error;
  }
};

export const getSiteById = async (siteId) => {
  try {
    const response = await api.get(`/sites/${siteId}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching site by ID:", error);
    throw error;
  }
};

// Optional: Add pagination support
export const getSitesWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  status = "",
  regionId = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (status) params.append("status", status);
    if (regionId) params.append("region_id", regionId);

    const response = await api.get("/sites/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching sites with pagination:", error);
    throw error;
  }
};

// Optional: Add site status management
export const updateSiteStatus = async (siteId, statusData) => {
  try {
    const response = await api.put(`/sites/${siteId}/status/`, statusData);
    return response.data;
  } catch (error) {
    console.error("Error updating site status:", error);
    throw error;
  }
};

// Optional: Add site configuration management
export const getSiteConfig = async (siteId) => {
  try {
    const response = await api.get(`/sites/${siteId}/config/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching site configuration:", error);
    throw error;
  }
};

export const updateSiteConfig = async (siteId, configData) => {
  try {
    const response = await api.put(`/sites/${siteId}/config/`, configData);
    return response.data;
  } catch (error) {
    console.error("Error updating site configuration:", error);
    throw error;
  }
};

// Optional: Add bulk operations
export const bulkUpdateSites = async (sitesData) => {
  try {
    const response = await api.put("/sites/bulk-update/", sitesData);
    return response.data;
  } catch (error) {
    console.error("Error bulk updating sites:", error);
    throw error;
  }
};

export const bulkDeleteSites = async (siteIds) => {
  try {
    const response = await api.post("/sites/bulk-delete/", {
      site_ids: siteIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error bulk deleting sites:", error);
    throw error;
  }
};

// Optional: Add site metrics
export const getSiteMetrics = async (siteId, timeframe = "day") => {
  try {
    const response = await api.get(`/sites/${siteId}/metrics/`, {
      params: { timeframe },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching site metrics:", error);
    throw error;
  }
};

// Optional: Add site probe management
export const getSiteProbes = async (siteId) => {
  try {
    const response = await api.get(`/sites/${siteId}/probes/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching site probes:", error);
    throw error;
  }
};

export const updateSite = async (siteId, siteData, schemaName=null) => {
  try {
    const response = await api.put(`/sites/${siteId}/`, siteData, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error in updateSite service:", error);

    if (error.response) {
      // Log the specific error details
      console.error("Server validation errors:", error.response.data);

      // Enhance the error object with more details
      error.details = error.response.data;
    }

    throw error;
  }
};
